import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';

import { FormField } from '../../models/form-builder/form-field.model';
import { FormInstanceElement } from '../../models/form-builder/form-instance-element.model';
import { FieldDefinitionService } from '../../services/field-definition.service';
import { FieldDefinition } from '../../models/form-builder/field-definition.model';
import { FormInstance } from '../../models/site-content/form-instance.model';
import { FormFieldBaseComponent } from '../../components/form-fields/form-field-base/form-field-base.component';

// Define a class for invoking the grid cell editor v2 dialogue.
export class GridCellEditorV2DialogManager {
    // Property.
    public constructor(public formField: FormField,
        public formInstanceElement: FormInstanceElement,
        public gridColumnDefs: FormField[],
        public gridRowId: number,
        public formInstance: FormInstance) {
    }

    public openDialogUsing(dialog: MatDialog): MatDialogRef<GridCellEditorV2Dialog, any> {
        const dialogRef = dialog.open(GridCellEditorV2Dialog,
            {
                data: this,
                hasBackdrop: false, // See https://stackblitz.com/edit/angular-173jnz?file=src%2Fapp%2Fdialog-content-example.ts for an example of how to use this.
                width: '500px',
                height: '350px',
                panelClass: 'custom-mat-dialog-panel'
            });
        return dialogRef;
    }

    public get DialogContentDivHeightStyle(): string {
        // Note:  this height needs to be coordinated with the dialogue's height, set just above.
        return 'height: 590px;';
    }
}

@Component({
    selector: 'app-grid-cell-editor-v2',
    //imports: [],
    templateUrl: './grid-cell-editor-v2.dialog.html',
    styleUrl: './grid-cell-editor-v2.dialog.scss',
    standalone: false
})
export class GridCellEditorV2Dialog {
    // Properties.
    private wrappedFormInstanceElement: FormInstanceElement;

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<GridCellEditorV2Dialog>,
        @Inject(MAT_DIALOG_DATA) public initData: GridCellEditorV2DialogManager,
        private fieldDefinitionService: FieldDefinitionService) {

    }

    // Define/implement methods called by my HTML code.
    public get Title(): string {
        const cellName: string = this.initData.formField.displayName != null ? this.initData.formField.displayName : this.initData.formField.name;
        const title: string = `Edit Cell ${cellName}`;
        return title;
    }

    public get GridRowId(): number {
        return this.initData.gridRowId;
    }
    public get GridColumnDefs(): FormField[] {
        return this.initData.gridColumnDefs;
    }
    public get FormField(): FormField {
        return this.initData.formField;
    }
    public get FormInstance(): FormInstance {
        return this.initData.formInstance;
    }

    public get FormInstanceElement(): FormInstanceElement {
        return this.initData.formInstanceElement;
    }

    public set FormInstanceElement(value: FormInstanceElement) {
        this.initData.formInstanceElement = value;
    }

    // End methods called by my HTML code.

    // Begin methods that handle control events.
    public gridColumnInit(hshEventData: any, hshUnusedColumnDef: FormField): void {
        //console.log('gridColumnInit()', hshEventData, hshUnusedColumnDef);
    }

    public handleWrapperFormControlCreated(control: any) {
        // TO DO:  CODE THIS METHOD.
    }

    public handleMimickedNgModelChange(eventData: any): void {
        this.wrappedFormInstanceElement = eventData.formInstanceElement;
    }

    public handleTouched(formFieldComponent: FormFieldBaseComponent): void {
        // TO DO:  CODE THIS METHOD.
    }

    public handleValidityChange(state: string) {
        // TO DO:  CODE THIS METHOD.
    }

    public applyEnteredValue(): void {
        this.dialogRef.close(this.wrappedFormInstanceElement);
    }

    public cancel(): void {
        this.dialogRef.close(null);
    }
    // End methods that handle control events.
}
